<template>
  <div class="comments">
    <div>
      <b-jumbotron header="" lead="">
        <h1 class="display-3" style="font-size: 2rem; font-weight: 600;">Статус перевозки</h1>
        <p class="lead" v-html="lastComment.comment"></p>
      </b-jumbotron>
    </div>
  </div>
</template>

<script>
import { mixinComments } from "@/mixins/mixinComments";

export default {
  mixins: [mixinComments],

  props: {
    orderServiceId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      comments: [],
      lastComment: {},
      files: [],
      savingComment: false,
      apiName: 'service',
      idName: 'order_service_id',
    };
  },

  components: {
  },

  computed: {
    currentId() {
      return this.orderServiceId;
    }
  },

  methods: {
    async fetchComments() {
      this.comments = await this.$api.service.getComments(this.orderServiceId);
      this.lastComment = this.comments.pop();
    },
  },

  async mounted() {
    this.fetchComments();
  },
};
</script>

<style lang="scss" scoped>
.comment {
  margin-bottom: 10px;
  background: #f3f3f3;
}
</style>
